import React, {Component} from 'react';
import { connect } from "react-redux";
import DispatchListItem from './dispatch-item';
import {onClickScheduledFastForward} from '../../data/actions/scheduled';
import {i18n_get_value, I18N_LABELS} from '../../../i18n/i18n_scripts';
import './dispatch-list.css';



class DispatchList extends Component {
 
    isOrderSelected(order) {
        return this.props.orderSelected && this.props.orderSelected.id === order.id;
    }

    render() {


        const scheduledData = (this.props.data ? this.props.data : []);

        const totalOrders = scheduledData.length;

        const scheduled = this.props.scheduled.scheduled;


        return (
            <div className="orders-list__wrapper">
                <div className="orders-list__header">
                    <span>{i18n_get_value(I18N_LABELS.SIDEBAR_ORDERS_SCHEDULED_LABEL)}</span>
                    <span className="orders-list__header-count">{totalOrders}</span>
                </div>
                <div className="dispatch-list">
                    {scheduledData.map(scheduledOrder => (
                        <DispatchListItem
                            key={scheduledOrder.id}
                            data={scheduledOrder}
                            onClickAction={this.onClickFastForward.bind(this)}
                            scheduled={scheduled}
                        />
                    ))}
                </div>
            </div>
        );
    }


    onClickFastForward(scheduledOrder, event){
        console.log("Fast Forward for order: " + scheduledOrder.id);
        this.props.onClickScheduledFastForward(scheduledOrder)
    }

}

const mapDispatchToProps = {
    onClickScheduledFastForward,
}

export default connect(null, mapDispatchToProps)(DispatchList);
